<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 32 24.89"
  >
    <g
      :fill="color"
      class="fill-current"
    >
      <path d="M28.61,0h0c-1.34,0-8,.49-12.2,2.67a.93.93,0,0,1-.8,0C11.44.49,4.74,0,3.4,0h0A3.34,3.34,0,0,0,0,3.28V19.77A3.33,3.33,0,0,0,3.21,23a39,39,0,0,1,10.11,1.68,2.52,2.52,0,0,0,.9.17h3.56a2.52,2.52,0,0,0,.9-.17A39,39,0,0,1,28.79,23,3.33,3.33,0,0,0,32,19.77V3.28A3.34,3.34,0,0,0,28.61,0ZM15.11,22.28a.84.84,0,0,1-.85.84,1,1,0,0,1-.3-.05A39.76,39.76,0,0,0,3.3,21.26a1.55,1.55,0,0,1-1.52-1.49V3.28a1.56,1.56,0,0,1,1.61-1.5A33.65,33.65,0,0,1,14.07,3.91a1.71,1.71,0,0,1,1,1.55V22.28Zm15.11-2.51a1.55,1.55,0,0,1-1.52,1.49A40.16,40.16,0,0,0,18,23.07a1,1,0,0,1-.3.05.84.84,0,0,1-.85-.84V5.45a1.68,1.68,0,0,1,1-1.54A33.38,33.38,0,0,1,28.61,1.78a1.56,1.56,0,0,1,1.61,1.49Z" />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    width: {
      type: String,
      default: ''
    },
    height: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: 'currentColor'
    }
  }
}
</script>
